var _defs, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .767h35.792v10.954H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .238h35.804V11H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "exclusion"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    d: "M15.667 2.961c1.855 0 3.358 1.47 3.358 3.284 0 1.812-1.503 3.282-3.358 3.282-1.854 0-3.358-1.47-3.358-3.282.003-1.813 1.505-3.282 3.358-3.284zM1.12 7.337h9.065c.614 2.96 3.565 4.874 6.593 4.274 2.203-.436 3.924-2.12 4.371-4.274h13.525c.617 0 1.118-.49 1.118-1.092 0-.604-.5-1.094-1.118-1.094H21.15c-.614-2.96-3.565-4.874-6.592-4.274-2.203.436-3.925 2.12-4.372 4.274H1.12c-.619 0-1.12.49-1.12 1.095S.5 7.341 1.12 7.341v-.004z",
    mask: "url(#b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    d: "M10.07 8.841c-1.854 0-3.358-1.443-3.358-3.224 0-1.78 1.504-3.224 3.358-3.224 1.855 0 3.358 1.443 3.358 3.224-.002 1.78-1.505 3.223-3.358 3.224zm24.616-4.298H15.552C14.938 1.636 11.987-.243 8.96.346 6.757.774 5.035 2.428 4.588 4.543H1.12C.502 4.543 0 5.025 0 5.62c0 .594.502 1.076 1.12 1.076h3.468c.614 2.907 3.565 4.786 6.593 4.197 2.203-.429 3.924-2.082 4.371-4.197h19.134c.618 0 1.118-.481 1.118-1.074 0-.593-.5-1.074-1.118-1.074v-.004z",
    mask: "url(#d)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    d: "M26.853 20.265c-1.854 0-3.357-1.47-3.357-3.284 0-1.812 1.503-3.282 3.357-3.282 1.855 0 3.358 1.47 3.358 3.282-.002 1.813-1.504 3.281-3.358 3.284zm7.833-4.376h-2.35c-.614-2.96-3.566-4.874-6.593-4.274-2.203.436-3.925 2.12-4.371 4.274H1.12c-.619 0-1.12.49-1.12 1.095s.501 1.095 1.12 1.095h20.252c.613 2.96 3.564 4.873 6.592 4.274 2.203-.437 3.924-2.12 4.371-4.274h2.35c.619 0 1.12-.489 1.12-1.093s-.5-1.093-1.118-1.093h-.001v-.004z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.a88a1c084c2a0d285e93f04a58ecd9ac.svg";
export { ForwardRef as ReactComponent };